import { useTranslation } from "react-i18next";

import type { TooltipMessageProps } from "./TooltipMessage.decl";

export function TooltipMessage({ title, description }: TooltipMessageProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center">
      <p className="text-sm font-medium text-primary-foreground">{t(title)}</p>
      {!!description && (
        <p className="text-sm font-medium text-muted-foreground">
          {t(description)}
        </p>
      )}
    </div>
  );
}
